import CountryEditor from './Widget/CountryEditor';
import { Question, Serializer } from 'survey-core';
import React from 'react';

import {
  SurveyQuestionElementBase,
  ReactQuestionFactory,
} from 'survey-react-ui';
import { CountryType } from '@deeptrue-frontend/ui/build/utils/survey/widgets/CountryV2/widget';

// create model for new question type
export class QuestionCountryEditorModel extends Question {
  getType() {
    return 'countryList';
  }
  get countryListType() {
    return this.getPropertyValue('countryList');
  }
  set countryListType(val) {
    this.setPropertyValue('countryList', val);
  }
}

// this serializes the class into JSON
Serializer.addClass(
  'countryList',
  [
    {
      name: 'countryListType',
    },
  ],
  function () {
    return new QuestionCountryEditorModel('');
  },
  'question'
);

export class SurveyCountryEditor extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.state = { value: this.question.value };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  set value(data) {
    this.question.value = data;
  }

  saveToLocalStorage(data: CountryType[]) {
    localStorage.setItem('countryWidget', JSON.stringify(data));
  }

  loadFromLocalStorage() {
    const res = localStorage.getItem('countryWidget');

    return res ? JSON.parse(res) : [];
  }

  get type() {
    // @ts-ignore
    return this.question.countryListType;
  }
  handleCountryEditorChange = (data: any) => {
    this.question.value = data;

    this.saveToLocalStorage(data);
  };

  renderElement() {
    const valueToRender =
      this.value && this.value.length > 0
        ? this.value
        : this.loadFromLocalStorage();

    return (
      <CountryEditor
        onChange={this.handleCountryEditorChange}
        value={valueToRender}
      />
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion('countryList', (props: any) => {
  return React.createElement(SurveyCountryEditor, props);
});
